import type { FaireProductEntity } from "../../entity_types/product";

export const p_ved47j3xct: FaireProductEntity = {
  token: "p_ved47j3xct",
  type: "product",
  name: "Modal Eyelet Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/2dd98e2ecb0c1ca9df5ef09d40640f9a340549242a103194700759aaf01d0a11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/214c8ecd9cebbb051b506bc510b2f20f66eb984aff867810d2ca7ad5f5ba38e6.jpeg",
    "https://cdn.faire.com/fastly/adda65457d2e27d54593c351c63bdbcaae97c2724d8b5fb92af9fda232d87107.jpeg",
    "https://cdn.faire.com/fastly/36bbabf8281b07edd193dc18a88161f3de8ef0361c4efc14862ba1a23c3a5d26.jpeg",
    "https://cdn.faire.com/fastly/70a9db745aae49c4dac6caa7234b87896bd5bdf0d62a41d4b9010965386afbdf.jpeg",
    "https://cdn.faire.com/fastly/0a6178cf1f27e504055d640ead3ece70d20049cfccc11ed88629b238e6b29e13.jpeg",
    "https://cdn.faire.com/fastly/c078bb9a975774f9c49dc15e741afbf7a12b5ff48318a174fcf130373cd71855.jpeg",
    "https://cdn.faire.com/fastly/cb644f33754b0e23e2ebb075849f79bc26bd3adedbdb8c47e6558ce3acaea96e.jpeg",
    "https://cdn.faire.com/fastly/1508cd82e14ae70eac7a533f71ed3ef119d6b33d2a2507a067e325c3ae8b8571.jpeg",
    "https://cdn.faire.com/fastly/21bc754e46b4f7c8b889a8ae0cfba168b9c2841db7325116bda2b6b1e72d24eb.jpeg",
    "https://cdn.faire.com/fastly/144da27958fcea8cf31e865d3e92d34927303b14344ff102d39db4ee669498aa.jpeg",
    "https://cdn.faire.com/fastly/0d8d05b046db756ae98cbac4ae70ae95ac4ce26b78e7704015751f2a53710196.jpeg",
    "https://cdn.faire.com/fastly/cf08074f267706a4402758adf04ce5e5e9ffe835f0708f410215438a0df41bb6.jpeg",
    "https://cdn.faire.com/fastly/23870ff31724289412e664cd3a9df611ffd66c02706868a6eb2a7fdb0816bdfe.jpeg",
    "https://cdn.faire.com/fastly/c6773350694442700936c2d0477be72517c04533ad56b384bb452fce8a151908.jpeg",
    "https://cdn.faire.com/fastly/a69ad711b50a21551143c0ef24f2bf38bc57b7229091fd614f3123ef35f4c305.jpeg",
    "https://cdn.faire.com/fastly/4b81397654b46df5aac7c25b53077b5b425fe3565ffd41d173417bd296f1533c.jpeg",
    "https://cdn.faire.com/fastly/b952005bd66cd04a5a5ceb6f9f1b9f14e615adc4dc32b75f0e7a0a40b3c47ff2.jpeg",
  ],
  priceDollars: 8,
  description:
    "Why we made this?\n\nA refreshing take on pointelle. Delicate in detail, the Modal Eyelet Sock echoes the look of our Pointelle Cashmere with a similar knit pattern, while feeling closer in weight to the Trouser Sock. Soft with a silky-smooth hand, it’s the perfect pair for lighter seasons—made to wear with sandals and flats.\n\nMade in South Korea\n\nContents:\n\nModal 93%, Polyester 6%, Spandex 1%\n\nSizing:\n\nOne size fits most (US women's size 6-10)\n\nCare Instructions:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\nMSRP: $18 USD",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:05.364Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
